import { Observable } from 'rxjs';
import { IDynForm } from '../common/models';

export abstract class FormsDataServiceInterface {
    abstract getFormByKey(key: string);
    abstract postFormData(object: any): Observable<any>;
    abstract getFormsByDirectory?(directory: string): Observable<IDynForm[]>;
}
